import Vue from 'vue';
import Buefy from 'buefy';

import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import ru from 'vee-validate/dist/locale/ru.json';

import dayjs from 'dayjs';
import dayjsRuLocale from 'dayjs/locale/ru';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css'; // import styles
import 'quill/dist/quill.snow.css'; // for snow theme

import components from './components';

// Date and Time
dayjs.locale('ru');
dayjs.extend(relativeTime);
dayjs.extend(utc);

// Buefy
Vue.use(Buefy, {
  defaultDateFormatter: date => dayjs(date).format('DD.MM.YYYY'),
  defaultDateParser: date => dayjs(date).toDate(),
  defaultDateCreator: () => new Date(),
  defaultDayNames: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  // defaultMonthNames: dayjsRuLocale.months,
  defaultLocale: 'ru-RU',
});

// VeeValidate
localize('ru', ru);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// Quill (Rich Text Editor)
Vue.use(VueQuillEditor, {
  theme: 'snow',
  modules: {
    table: true,
    syntax: true,
  },
});

// Components
Object.keys(components).forEach(k => {
  Vue.component(components[k].name, components[k]);
});

// Pusher
// window.Echo = new Echo({
//   broadcaster: 'pusher',
//   key: 'fc80280191cb0fc98157', // @todo refactor
//   cluster: 'eu',
//   encrypted: true,
//   authEndpoint: '/api/broadcasting/auth?token=' + window.localStorage.getItem('api:token'), // @todo refactor
// });

Vue.filter('datetime', (value, format = 'D MMMM YYYY - HH:mm') => {
  return value ? dayjs(value).format(format) : '';
});
